import { getData, postData } from '@/utils/http'
import config from "@/config"

export default {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {

        //获取驾驶员信息
        getDriverData({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/driver/get/idle/list2?name=${data.name}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取车辆信息
        getCarData({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/car/get/idle/list2?code=${data.code}&carNo=${data.carNo}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },


        //获取驾驶员信息
        getDriverDataOut({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/driver/get/un/idle/list2?name=${data.name}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取车辆信息
        getCarDataOut({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/car/get/un/idle/list2?code=${data.code}&carNo=${data.carNo}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },

        //获取挂车信息
        getGuaCarList({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/car/get/idle/list3?code=${data.code}&carNo=${data.carNo}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        },
        //获取外部挂车
        getGuaOutList({ commit, state }, data) {
            return new Promise(resolve => {
                getData(`logistics/car/get/un/idle/list3?code=${data.code}&carNo=${data.carNo}&deptId=${data.deptId}`).then(res => {
                    if (res.state == 1) {
                        resolve({
                            state: 1,
                            data: res.data,
                            msg: '操作成功'
                        })
                    } else {
                        resolve({
                            state: 0,
                            data: null,
                            msg: res.msg
                        })
                    }
                })
            })
        }
    }
}
